import { ref, computed } from 'vue';
import { CoresHelper } from '@/utils/coresHelper';

const especialidadeAtual = ref<string | undefined>(undefined);

export function useEspecialidade() {
  const definirEspecialidade = (especialidade?: string) => {
    especialidadeAtual.value = especialidade;
    CoresHelper.aplicarCoresPorEspecialidade(especialidade);
  };

  const coresAtuais = computed(() => CoresHelper.getCoresAtuais());

  const logoAtual = computed(() => CoresHelper.getLogoPorEspecialidade(especialidadeAtual.value));
  const logoVerticalAtual = computed(() => CoresHelper.getLogoVerticalPorEspecialidade(especialidadeAtual.value));

  const classeEspecialidade = computed(() => CoresHelper.getClasseEspecialidade(especialidadeAtual.value));

  return {
    especialidadeAtual: computed(() => especialidadeAtual.value),
    definirEspecialidade,
    coresAtuais,
    logoAtual,
    logoVerticalAtual,
    classeEspecialidade,
  };
}
